<template>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12 sm6 md6 lg5>
                    <v-layout justify-center>
                        <v-img max-width="70%"
                                src="../../img/egk_logo.png"></v-img>
                    </v-layout>
                    <v-spacer class="mt-4"></v-spacer>
                    <v-spacer></v-spacer>
                    <v-form class="ml-4 mr-4">
                        <ValidationObserver ref="form">
                            <ValidationProvider :name="$t('login_account')" rules="required" v-slot="{ errors }">
                            <v-text-field v-model="account"
                                            prepend-icon="mdi-account"
                                            :placeholder="$t('login_account')"
                                            type="text"
                                            @keyup.enter="submit"
                                            :error-messages="errors[0]"
                                            color="#2DA7E0"
                                            required></v-text-field>
                            </ValidationProvider>
                            <ValidationProvider :name="$t('login_password')" rules="required" v-slot="{ errors }">
                            <v-text-field id="password"
                                            v-model="password"
                                            prepend-icon="mdi-key"
                                            :placeholder="$t('login_password')"
                                            type="password"
                                            @keyup.enter="submit"
                                            :error-messages="errors[0]"
                                            color="#2DA7E0"
                                            required></v-text-field>
                            </ValidationProvider>
                            <v-checkbox
                                v-model="rememberAccount"
                                :label="$t('login_remember_account')"
                                color="#2DA7E0"
                                hide-details
                                class="mt-1"
                            ></v-checkbox>
                        </ValidationObserver>
                    </v-form>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-layout justify-center>
                        <v-flex xs12 sm12 md12 lg12 style="padding-left: 55px;padding-right: 22px;">
                            <v-btn class="mt-4" block rounded dark color="#2DA7E0" :disabled="!valid" v-on:click="submit">{{ $t('login_btn') }}</v-btn>
                        </v-flex>
                    </v-layout>
                    <!--<v-layout justify-center>
                        <v-flex xs12 sm12 md12 lg12 style="padding-left: 55px;padding-right: 22px;">
                            <v-alert
                                :value="alert"
                                color="warning"
                                icon="priority_high"
                                outlined
                                >
                                {{$t('Login_Fail_Please_Check_Account_And_Password')}}
                            </v-alert>
                        </v-flex>
                    </v-layout>-->
                </v-flex>
            </v-layout>
        </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import i18n from '@/i18n'
import { navigateAfterLogin, resolveLoginRedirect } from '@/js/auth-redirect'
import {
  clearRememberedAccount,
  loadRememberedAccount,
  saveRememberedAccount
} from '@/js/login-preferences'

export default {
  data () {
    return {
      isShowLoginDialog: true,
      drawer: null,
      valid: true,
      isBackendValidFail: false,
      resultCode: 0,
      account: '',
      password: '',
      rememberAccount: false,
      alert: false
    }
  },
  created: function () {
    const remembered = loadRememberedAccount()
    if (remembered) {
      this.account = remembered
      this.rememberAccount = true
    }
  },
  methods: {
    ...mapActions('login', {
      Login: 'login'
    }),
    async submit () {
      try {
        let data = {
          UserName: this.account,
          Password: this.password
        }
        let isLogin = await this.Login(data)

        if (isLogin) {
          if (this.rememberAccount) {
            saveRememberedAccount(this.account)
          } else {
            clearRememberedAccount()
          }
          const target = resolveLoginRedirect(this.$route.query.redirect)
          await navigateAfterLogin(this.$router, target, () => window.location.reload())
        } else {
          alert(i18n.t('login_alert_message'))
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
